import React, { useState, useEffect, useRef } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  Breadcrumb,
  Button,
  Checkbox,
  Col,
  Form,
  Input,
  Row,
  Select,
  Spin,
  Table,
  Tooltip,
} from "antd";
import {
  ErrorNotificationMsg,
  SuccessNotificationMsg,
} from "../../utils/Notifications";
import {
  getRequest,
  getRequest1,
  patchRequest,
  postRequest,
} from "../../axios";
import { authUserData } from "../../utils/Helper";
import { FilterFilled } from "@ant-design/icons";
import { ReactComponent as RupeesSign } from "../../image/RupeesSign.svg";
import ButtonField from "../../common/htmlComponents/ButtonField";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import procem from "../../image/PROCEM3.svg";


const PreviewAndSendApprovalDiameterWise = () => {
  const { t } = useTranslation();
  const { Option } = Select;
  const CompanyId = authUserData()?.company ? authUserData()?.company : null;
  const [reload, setReload] = useState(false);
  const [siteName, setSiteName] = useState([]);
  const [materialName, setMaterialName] = useState([]);
  const [enableInputs, setEnableInputs] = useState(false);
  const { id } = useParams();
  const navigate = useNavigate();
  const { Search } = Input;
  const [totalCount, settotalCount] = useState(0);
  const [rfqHistory, setRFQHistory] = useState([]);
  const [categoryTree, setCategoryTree] = useState([]);
  const [siteDetails, setSiteDetails] = useState(null);
  const [initialRender, setInitialRender] = useState(true);
  const formRef = useRef();
  const [totalAm, setTotalAm] = useState(0);
  const [loading, setLoading] = useState(false);

  const pdfContainerRef = useRef(null);
  const buttonRef = useRef(null);
  const [state, setState] = useState({
    // page: 1,
    // ordering: "id",
    // pagesize: 10,
    // search: "",
    // total: 0,
    hide_r0_price: false,
    hide_r1_price: false,
    hide_r_price: false,
    site_id: [],
    material_type_id: [],
  });

  const [hideInitialBidPrice, sethideInitialBidPrice] = useState(false);
  const [hideR1BidPrice, setHideR1BidPrice] = useState(false);
  const [hideRBidPrice, setHideRBidPrice] = useState(false);
  const [showUnitRateCementR1, setShowUnitRateCementR1] = useState(false);
  const [showUnitRateCementR, setShowUnitRateCementR] = useState(false);
  const [isFinalBidPrice, setIsFinalBidPrice] = useState(false);
  const [showAdditionalCheckboxesFinal, setShowAdditionalCheckboxesFinal] =
    useState(true);
  const [showAdditionalCheckboxes, setShowAdditionalCheckboxes] =
    useState(false);
  const [comparativesRFQ, setComparativesRFQ] = useState([]);
  const [rfqNumber, setRfqNumber] = useState(null);
  const [poTotalAmount, setPoTotalAmount] = useState(0);
  const [apiLoading, setapiloading] = useState(false);
  const [floatId, setFloatId] = useState(null);
  const [btnLoading, setBtnLoading] = useState(false);

  const [buyer, setBuyer] = useState(null);
  const [firstApprover, setFirstApprover] = useState(null);
  const [secondApprover, setSecondApprover] = useState(null);
  const [isDownloading, setIsDownloading] = useState(false);
  const [isCompleted, setIsCompleted] = useState(false);
  const [categoryType, setCategoryType] = useState(null);
  useEffect(() => {
    const getVendorBidRFQ = async () => {
      setapiloading(true);
      try {
        // const response = await getRequest(`po-order/250/get-purchase-order-approval/`);
        const response = await getRequest(
          `po-order/${id}/preview-and-send-for-approval/`
        );

        setFloatId(response.data.data.float_rfq);

        if (response.data.data) {
          setRfqNumber(response.data.data.rfq_number);
          setBuyer(response.data.data.buyer_name);
          setFirstApprover(response.data.data.first_approver_name);
          setSecondApprover(response.data.data.second_approver_name);
          setPoTotalAmount(response?.data?.data?.total_amount);
          setIsCompleted(response?.data?.data?.po_approval);
          // const responseData = response?.data?.data?.site_wise_data;
          const responseData =
            response?.data?.data?.purchase_order_city_details;

          // const tableData = response?.data?.data?.summery_of_price_comparative?.map((item, index) => {

          const tableData = responseData?.map((item, index) => {
            const citySubTotal = item.vendor_city_total.reduce(
              (acc, amount) => acc + amount.amount_with_gst,
              0
            );

            const citySubTotalWithoutGST = item.vendor_city_total.reduce(
              (acc, amount) => acc + amount.amount_without_gst,
              0
            );

            return {
              key: item.po_city_name,
              cityName: item.po_city_name,
              citySubTotal: citySubTotal,
              citySubTotalWithoutGST: citySubTotalWithoutGST,
              comparative: item.purchase_order_site_details.map((com, ind) => {
                const siteSubTotal =
                  com.vendor_site_sub_total[0].amount_without_gst;
                const siteSubTotalWithGST =
                  com.vendor_site_sub_total[0].amount_with_gst;

                return {
                  siteName: com.rfq_site_name,
                  siteId: com.rfq_site_id,
                  siteSubTotal: siteSubTotal,
                  siteSubTotalWithGST: siteSubTotalWithGST,
                  vendorWise: com.po_vendor_detail.map((it, index) => {

                    return {
                      vendorName: it.vendor_name,
                      rank: {
                        comparison_ranking: it.comparison_ranking,
                        selected_seasons: it.selected_seasons,
                        other_reason_text: it.other_reason_text,
                      },
                      siteLocations: it.po_material_detail.map(
                        (item1, index) => {
                          return {
                            materialName: item1.bid_material_type_name,
                            quantity: item1.bid_material_quantity,
                            uom: item1.bid_uom,
                            r_unit_price: Number(item1.unit_rate),
                            r_total_price: item1.amount_without_gst,
                            total_amount_with_gst: item1.amount_with_gst,
                            diameter_details: item1.diameter_details,
                          };
                        }
                      ),
                    };
                  }),
                };
              }),
            };
          });
          setComparativesRFQ(tableData);
          if (response.data.data.category_tree_name === "cement") {
            setCategoryType(true);
          } else {
            setCategoryType(false);
          }
          const poTotalAmount = responseData?.reduce((total, item) => {
            const cityTotal = item.vendor_city_total.reduce(
              (acc, vendor) => acc + vendor.amount_with_gst,
              0
            );
            return total + cityTotal;
          }, 0);

          setPoTotalAmount(poTotalAmount);

          //       const sites = response.data.data.site_wise_data.map(item => ({
          //         id: item.site_id,
          //         name: item.site_name
          //       }));
          //       setSiteName(sites);

          //       const materialTypes = response.data.data.site_wise_data.flatMap(item =>
          //         item.material_wise_data.map(material => ({
          //           id: material.rfq_material_type_id,
          //           name: material.material_name
          //         }))
          //       );

          //       const uniqueMaterialTypes = materialTypes.filter((material, index, self) =>
          //         index === self.findIndex(m => m.id === material.id && m.name === material.name)
          //       );

          //       setMaterialName(uniqueMaterialTypes);

          setapiloading(false);
        } else {
          ErrorNotificationMsg(t("Error in Comparatives"));
          setapiloading(false);
        }
      } catch (error) {
        console.error("Error:", error);
        setapiloading(false);
      }
    };
    getVendorBidRFQ();
  }, [id]);

const downloadAsPDF = async () => {
  if (pdfContainerRef.current) {
    setIsDownloading(true);
    if (buttonRef.current) {
      buttonRef.current.classList.add("hide-in-pdf");
    }

    try {
      const canvas = await html2canvas(pdfContainerRef.current, {
        useCORS: true,
        scale: 1.5,
        logging: true,
      });

      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");

      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();

      const marginX = 10; 
      const marginY = 10; 

      const imgProps = pdf.getImageProperties(imgData);
      const imgWidth = pdfWidth - marginX * 2;
      const imgHeight = (imgProps.height * imgWidth) / imgProps.width;

      let heightLeft = imgHeight;
      let position = 0;

      const logoUrl = procem 
      const logoWidth = 20; 
      const logoHeight = 5; 
      const logoX = pdfWidth - logoWidth - marginX;
      const logoY = 2; 

      const logoImg = await new Promise((resolve) => {
        const img = new Image();
        img.crossOrigin = "anonymous";
        img.src = logoUrl;
        img.onload = () => resolve(img);
      });

      const logoCanvas = document.createElement("canvas");
      logoCanvas.width = logoImg.width;
      logoCanvas.height = logoImg.height;
      const ctx = logoCanvas.getContext("2d");
      ctx.drawImage(logoImg, 0, 0);
      const logoBase64 = logoCanvas.toDataURL("image/png");

      pdf.addImage(logoBase64, "PNG", logoX, logoY, logoWidth, logoHeight);
      pdf.addImage(
        imgData,
        "PNG",
        marginX,
        position + marginY,
        imgWidth,
        imgHeight
      );

      heightLeft -= pdfHeight - marginY * 2;

      while (heightLeft > 0) {
        pdf.addPage();
        pdf.addImage(logoBase64, "PNG", logoX, logoY, logoWidth, logoHeight);

        position = heightLeft - imgHeight;
        pdf.addImage(
          imgData,
          "PNG",
          marginX,
          position + marginY,
          imgWidth,
          imgHeight
        );
        heightLeft -= pdfHeight - marginY * 2;
      }

      pdf.save(`Preview Approval Order-${rfqNumber}.pdf`);
    } catch (error) {
      console.error(error);
    } finally {
      if (buttonRef.current) {
        buttonRef.current.classList.remove("hide-in-pdf");
      }
      setIsDownloading(false);
    }
  } else {
    console.error("PDF container reference is not defined.");
  }
};



  const handleCheckboxChange = () => {
    setIsFinalBidPrice(!isFinalBidPrice);
    setShowAdditionalCheckboxesFinal(true);

    setState((prevState) => ({
      ...prevState,
      is_final_bid_price: !isFinalBidPrice,
    }));
  };

  const handleCheckboxhideR1 = () => {
    sethideInitialBidPrice(!hideInitialBidPrice);
  };

  const handleCheckboxhideR = () => {
    setHideR1BidPrice(!hideR1BidPrice);
  };

  const handleCheckboxhideRR = () => {
    setHideRBidPrice(!hideRBidPrice);
  };

  const updateState = async () => {
    // try {
    //   const payload = {
    //     ...comparativesRFQ,
    //   }
    //   const response = await patchRequest(`comparative-rfq/${id}/get-comparative-details-by-site-wise/`, payload);
    //   console.log('response 100', response);
    //   if (response.data.data) {
    //     // Update state with the details of the selected site
    //     const responseData = response?.data?.data?.site_wise_data;
    //     const tableData = responseData?.map((item, index) => ({
    //       key: index + item.site_id,
    //       siteName: item?.site_name,
    //       siteLocations: item?.material_wise_data?.map((item1) => ({
    //         materialName: item1?.material_name,
    //         quantity: item1?.total_quantity_by_material,
    //         uom: item1?.material_uom,
    //         vendorBids: item1?.rfq_material_wise_bid_rfq_details?.map((item2) => ({
    //           vendorName: item2?.vendor_name,
    //           r_price: item2?.vendor_bid_rfq_details?.map((item3) => ({
    //             r_unit_price: item3?.r_price?.[0]?.r_unit_price,
    //             r_total_price: item3?.r_price?.[0]?.r_total_price,
    //           })),
    //           r1_price: item2?.vendor_bid_rfq_details?.map((item3) => ({
    //             r1_unit_price: item3?.r1_price?.[0]?.r1_unit_price,
    //             r1_total_price: item3?.r1_price?.[0]?.r1_total_price,
    //           })),
    //           r_price: item2?.vendor_bid_rfq_details?.map((item3) => ({
    //             r_unit_price: item3?.r_price?.[0]?.r_unit_price,
    //             r_total_price: item3?.r_price?.[0]?.r_total_price,
    //           })),
    //         })),
    //       })),
    //     }));
    //     setComparativesRFQ(tableData);
    //     // setComparativesRFQ(response)
    //   } else {
    //     ErrorNotificationMsg(t("Error fetching site details"));
    //   }
    // } catch (error) {
    //   console.error("Failed to fetch data:", error);
    // }
  };

  const handleSiteNameSelectChange = async (value) => {
    const updatedState1 = { ...state, site_id: value };
    setState(updatedState1);

    // if(!initialRender){
    //   updateState();
    // }
  };
  useEffect(() => {
    if (initialRender) {
      setInitialRender(false);
    } else {
      updateState();
    }
  }, [state]);

  const handleMaterialSelectChange = async (value) => {
    const updatedState2 = { ...state, material_type_id: value };
    setState(updatedState2);
  };

  const data = comparativesRFQ?.flatMap((city, cityIndex) =>
    city.comparative.flatMap((site, siteIndex) =>
      site.vendorWise.flatMap((vendor, vendorIndex) =>
        vendor.siteLocations.flatMap((material, materialIndex) =>
          (material.diameter_details || []).map((diameter, diameterIndex) => {
           return { key: `${cityIndex}-${siteIndex}-${vendorIndex}-${materialIndex}-${diameterIndex}`,
            "Sr.No": cityIndex + 1,
            City: city.cityName,
            "Site Name": site.siteName,
            "Vendor Name": vendor.vendorName,
            rank: vendor.rank,
            bid_material_type_sub_category: material.bid_material_sub_category,
            Items: material.materialName,
            Diameter: diameter.diameter_value,
            Quantity: diameter.diameter_quantity,
            UOM: material.uom,
            "Unit Rate": `\u20B9 ${Number(
              (diameter.unit_rate || "0").replace(/,/g, "")
            ).toLocaleString("en-IN", { maximumFractionDigits: 0 })}`,
            "Total Amount": `\u20B9 ${Number(
              diameter.amount_without_gst
            ).toLocaleString("en-IN", { maximumFractionDigits: 0 })}`,
            TotalAmountGST: `\u20B9 ${Number(
              diameter.amount_with_gst
            ).toLocaleString("en-IN", { maximumFractionDigits: 0 })}`,
            // For subtotal/city total calculations
            _amount_without_gst: Number(diameter.amount_without_gst),
            _amount_with_gst: Number(diameter.amount_with_gst)}
          })
        )
      )
    )
  );

  // Insert Sub Total and City Sub Total rows
  let processedDataWithTotals = [];
  let currentCity = null;
  let currentSite = null;
  let siteRows = [];
  let cityRows = [];

  function sumAmounts(rows, field) {
    return rows.reduce((sum, row) => sum + (row[field] || 0), 0);
  }

  function makeSiteTotalRow(rows, siteName) {
    const totalWithoutGST = sumAmounts(rows, '_amount_without_gst');
    const totalWithGST = sumAmounts(rows, '_amount_with_gst');
    return {
      key: `site-subtotal-${siteName}-${Math.random()}`,
      "Sr.No": '',
      City: '',
      "Site Name": 'Sub Total',
      "Vendor Name": '',
      rank: '',
      Items: '',
      Diameter: '',
      Quantity: '',
      UOM: '',
      "Unit Rate": '',
      "Total Amount": `\u20B9 ${totalWithoutGST.toLocaleString("en-IN", { maximumFractionDigits: 0 })}`,
      TotalAmountGST: `\u20B9 ${totalWithGST.toLocaleString("en-IN", { maximumFractionDigits: 0 })}`,
    };
  }

  function makeCityTotalRow(rows, cityName) {
    const totalWithoutGST = sumAmounts(rows, '_amount_without_gst');
    const totalWithGST = sumAmounts(rows, '_amount_with_gst');
    return {
      key: `city-subtotal-${cityName}-${Math.random()}`,
      "Sr.No": '',
      City: '',
      "Site Name": 'City Sub Total',
      "Vendor Name": '',
      rank: '',
      Items: '',
      Diameter: '',
      Quantity: '',
      UOM: '',
      "Unit Rate": '',
      "Total Amount": `\u20B9 ${totalWithoutGST.toLocaleString("en-IN", { maximumFractionDigits: 0 })}`,
      TotalAmountGST: `\u20B9 ${totalWithGST.toLocaleString("en-IN", { maximumFractionDigits: 0 })}`,
    };
  }

  data.forEach((row, idx) => {
    // New city
    if (row.City !== currentCity) {
      // If not first city, push city total
      if (cityRows.length > 0) {
        processedDataWithTotals.push(makeCityTotalRow(cityRows, currentCity));
        cityRows = [];
      }
      currentCity = row.City;
      currentSite = null;
    }
    // New site
    if (row["Site Name"] !== currentSite) {
      // If not first site, push site total
      if (siteRows.length > 0) {
        processedDataWithTotals.push(makeSiteTotalRow(siteRows, currentSite));
        siteRows = [];
      }
      currentSite = row["Site Name"];
    }
    processedDataWithTotals.push(row);
    siteRows.push(row);
    cityRows.push(row);

    // If last row, push both totals
    if (idx === data.length - 1) {
      if (siteRows.length > 0) processedDataWithTotals.push(makeSiteTotalRow(siteRows, currentSite));
      if (cityRows.length > 0) processedDataWithTotals.push(makeCityTotalRow(cityRows, currentCity));
    }
  });

  // Post-process data for display rules
  let lastCity = null;
  let lastSite = null;
  let lastMaterial = null;
  let srNo = 1;

  const processedData = processedDataWithTotals.map((row) => {
    
    if (row["Site Name"] === "Sub Total" || row["Site Name"] === "City Sub Total") {
      return row;
    }
    let showCity = false;
    let showVendorAndRank = false;
    let showSite = false;
    let showMaterial = false;

    if (row.City !== lastCity) {
      showCity = true;
      showVendorAndRank = true;
      showSite = true;
      showMaterial = true;
      lastCity = row.City;
      lastSite = row["Site Name"];
      lastMaterial = row.Items;
    } else if (row["Site Name"] !== lastSite) {
      showVendorAndRank = true;
      showSite = true;
      showMaterial = true;
      lastSite = row["Site Name"];
      lastMaterial = row.Items;
    } else if (row.Items !== lastMaterial) {
      showMaterial = true;
      lastMaterial = row.Items;
    }

    return {
      ...row,
      "Sr.No": showCity ? srNo++ : "",
      City: showCity ? row.City : "",
      "Site Name": showSite ? row["Site Name"] : "",
      Items: showMaterial ? row.Items : "",
      "Vendor Name": showVendorAndRank ? row["Vendor Name"] : "",
      rank: showVendorAndRank ? row.rank : "",
    };
  });

  const handleUnitRateOfCementChangeR0 = (
    value,
    recordKey,
    siteIndex,
    gstRate,
    quantity
  ) => {
    const updatedComparativesRFQ = [...comparativesRFQ];
    const record = updatedComparativesRFQ.find(
      (item) => item.key === recordKey
    );
    const site = record.siteLocations[siteIndex];
    site.vendorBids[0].r_price[0].r_unit_price = value;
    site.vendorBids[0].r_price[0].r_total_price =
      ((value * (100 + gstRate)) / 100) * quantity;
    setComparativesRFQ(updatedComparativesRFQ);
  };

  const handleUnitRateOfFreightChangeR0 = (value, recordKey, siteIndex) => {
    const updatedComparativesRFQ = [...comparativesRFQ];
    const record = updatedComparativesRFQ.find(
      (item) => item.key === recordKey
    );
    const site = record.siteLocations[siteIndex];
    site.vendorBids[0].r_price[0].r_unit_price = value;
    site.vendorBids[0].r_price[0].r_total_price = value * site.quantity;
    setComparativesRFQ(updatedComparativesRFQ);
  };

  const handleTotalUnitRateR0Change = (value, recordKey, siteIndex) => {
    const updatedComparativesRFQ = [...comparativesRFQ];
    const record = updatedComparativesRFQ.find(
      (item) => item.key === recordKey
    );
    const site = record.siteLocations[siteIndex];
    site.vendorBids[0].r_price[0].r_total_price = value;
    site.vendorBids[0].r_price[0].r_unit_price = value / site.quantity;
    setComparativesRFQ(updatedComparativesRFQ);
  };
  const [enableInputsR1, setEnableInputsR1] = useState(false);

  const handleUnitRateOfCementChangeR1 = (value, recordKey, siteIndex) => {
    const updatedComparativesRFQ = [...comparativesRFQ];
    const record = updatedComparativesRFQ.find(
      (item) => item.key === recordKey
    );
    const site = record.siteLocations[siteIndex];
    site.vendorBids[0].r1_price[0].r1_unit_price = value;
    site.vendorBids[0].r1_price[0].r1_total_price = value * site.quantity;
    setComparativesRFQ(updatedComparativesRFQ);
  };

  const calculateTotalUnitRateOfCementR1 = (record) => {
    const totalUnitRateOfCementR1 = record.siteLocations.reduce(
      (total, site) =>
        total + (parseFloat(site.vendorBids[0].r1_price[0].r1_unit_price) || 0),
      0
    );
    return totalUnitRateOfCementR1.toFixed(0);
  };

  const handleUnitRateOfFreightChangeR1 = (value, recordKey, siteIndex) => {
    const updatedComparativesRFQ = [...comparativesRFQ];
    const record = updatedComparativesRFQ.find(
      (item) => item.key === recordKey
    );
    const site = record.siteLocations[siteIndex];
    site.vendorBids[0].r1_price[0].r1_unit_price = value;
    site.vendorBids[0].r1_price[0].r1_total_price = value * site.quantity;
    setComparativesRFQ(updatedComparativesRFQ);
  };

  const handleTotalUnitRateOfCementR1Change = (value, recordKey, siteIndex) => {
    const updatedComparativesRFQ = [...comparativesRFQ];
    const record = updatedComparativesRFQ.find(
      (item) => item.key === recordKey
    );
    const site = record.siteLocations[siteIndex];
    site.vendorBids[0].r1_price[0].r1_total_price = value;
    site.vendorBids[0].r1_price[0].r1_unit_price = value / site.quantity;
    setComparativesRFQ(updatedComparativesRFQ);
  };
  const renderUnitRateOfCementR0 = (siteLocations, record) => {
    return (
      <>
        <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
          {siteLocations.map((site, siteIndex) => (
            <Input
              key={site.name + siteIndex}
              disabled={enableInputs}
              style={{ marginRight: "10px", width: "300px" }}
              // placeholder={`Enter Unit Rate of Cement for ${site.name}`}
              value={site.vendorBids[0].r_price[0].r_unit_price}
              onChange={(e) =>
                handleUnitRateOfCementChangeR0(
                  e.target.value,
                  record.key,
                  siteIndex,
                  site.vendorBids[0].gst_rate,
                  site.quantity
                )
              }
              type="number"
            />
          ))}
        </div>
      </>
    );
  };

  const vendors = (siteLocations, record) => {
    return (
      <>
        <div style={{ display: "flex", gap: "10px" }}>
          {record.siteLocations.map((site, siteIndex) => (
            <div key={siteIndex}>
              {site.vendorBids.map((vendor, vendorIndex) => (
                <>
                  <Input
                    key={vendorIndex}
                    disabled={enableInputs}
                    style={{ marginRight: "10px", width: "150px" }}
                    // placeholder={`Enter Unit Rate of Cement for ${site.name}`}
                    value={vendor.r_price[0].r_unit_price}
                    onChange={(e) =>
                      handleUnitRateOfCementChangeR0(
                        e.target.value,
                        record.key,
                        siteIndex,
                        vendor.gst_rate,
                        site.quantity
                      )
                    }
                    type="number"
                  />
                </>
              ))}
            </div>
          ))}
        </div>
      </>
    );
  };

  const calculateTotalUnitRateOfCementR0 = (record) => {
    const totalUnitRateOfCement = record.siteLocations.reduce(
      (total, site) =>
        total + (parseFloat(site.vendorBids[0].r_price[0].r_unit_price) || 0),
      0
    );
    return totalUnitRateOfCement.toFixed(0);
  };

  const renderUnitRateOfFreightR0 = (siteLocations, record) => {
    return (
      <>
        <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
          {siteLocations.map((site, siteIndex) => (
            <Input
              key={site.name + siteIndex}
              disabled={enableInputs}
              style={{ marginRight: "10px", width: "300px" }}
              placeholder={`Enter Unit Rate of Freight for ${site.name}`}
              value={site.vendorBids[0].r_price[0].r_unit_price}
              onChange={(e) =>
                handleUnitRateOfFreightChangeR0(
                  e.target.value,
                  record.key,
                  siteIndex
                )
              }
              type="number"
            />
          ))}
        </div>

        <Input
          placeholder={`Total Unit Rate of Freight R0`}
          prefix={<RupeesSign />}
          value={calculateTotalUnitRateOfFreightR0(record)} // Assuming unit_rate_of_cement is a property in the record
          style={{ width: "300px", top: "10px" }} // Adjust width as needed
          disabled
        />
      </>
    );
  };

  const calculateTotalUnitRateOfFreightR0 = (record) => {
    const totalUnitRateOfFreightR0 = record.siteLocations.reduce(
      (total, site) =>
        total + (parseFloat(site.vendorBids[0].r_price[0].r_unit_price) || 0),
      0
    );
    return totalUnitRateOfFreightR0.toFixed(0);
  };

  const calculateTotalUnitRateOfR0 = (record) => {
    const totalUnitRateOfCementR0 =
      parseFloat(calculateTotalUnitRateOfCementR0(record)) || 0;
    const totalUnitRateOfFreightR0 =
      parseFloat(calculateTotalUnitRateOfFreightR0(record)) || 0;

    return (totalUnitRateOfCementR0 + totalUnitRateOfFreightR0).toFixed(0);
  };

  const renderUnitRateOfCementR1 = (siteLocations, record) => {
    return (
      <>
        <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
          {siteLocations.map((site, siteIndex) => (
            <Input
              key={site.name + siteIndex}
              prefix={<RupeesSign />}
              disabled={enableInputsR1}
              style={{ marginRight: "10px", width: "300px" }}
              placeholder={`Enter Unit Rate of Cement for ${site.name}`}
              value={site.vendorBids[0].r1_price[0].r1_unit_price}
              onChange={(e) =>
                handleUnitRateOfCementChangeR1(
                  e.target.value,
                  record.key,
                  siteIndex
                )
              }
              type="number"
            />
          ))}
        </div>

        <div style={{ display: "flex", flexDirection: "column" }}>
          <Input
            placeholder={`Total Unit Rate of Cement R1`}
            prefix={<RupeesSign />}
            value={calculateTotalUnitRateOfCementR1(record)} // Assuming unit_rate_of_cement is a property in the record
            style={{ width: "300px", top: "10px" }} // Adjust width as needed
            disabled
          />
        </div>
      </>
    );
  };

  const renderUnitRateOfFreightR1 = (siteLocations, record) => {
    return (
      <>
        <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
          {siteLocations.map((site, siteIndex) => (
            <Input
              key={site.name + siteIndex}
              prefix={<RupeesSign />}
              disabled={enableInputsR1}
              style={{ marginRight: "10px", width: "300px" }}
              placeholder={`Enter Unit Rate of Freight for ${site.name}`}
              value={site.vendorBids[0].r1_price[0].r1_unit_price}
              onChange={(e) =>
                handleUnitRateOfFreightChangeR1(
                  e.target.value,
                  record.key,
                  siteIndex
                )
              }
              type="number"
            />
          ))}
        </div>

        <Input
          placeholder={`Total Unit Rate of Freight R1`}
          prefix={<RupeesSign />}
          value={calculateTotalUnitRateOfFreightR1(record)} // Assuming unit_rate_of_cement is a property in the record
          style={{ width: "300px", top: "10px" }} // Adjust width as needed
          disabled
        />
      </>
    );
  };

  const calculateTotalUnitRateOfFreightR1 = (record) => {
    const totalUnitRateOfFreightR1 = record.siteLocations.reduce(
      (total, site) =>
        total + (parseFloat(site.vendorBids[0].r1_price[0].r1_unit_price) || 0),
      0
    );
    return totalUnitRateOfFreightR1.toFixed(0);
  };

  const renderUnitRateOfTotalUnitRateR1 = (siteLocations, record) => {
    return (
      <>
        <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
          {siteLocations.map((site, siteIndex) => (
            <Input
              key={site.name + siteIndex}
              prefix={<RupeesSign />}
              disabled={enableInputsR1}
              style={{ marginRight: "10px", width: "300px" }}
              placeholder={`Enter Total Unit Rate for ${site.name}`}
              value={site.vendorBids[0].r1_price[0].r1_total_price}
              onChange={(e) =>
                handleTotalUnitRateOfCementR1Change(
                  e.target.value,
                  record.key,
                  siteIndex
                )
              }
              type="number"
            />
          ))}
        </div>

        <Input
          placeholder={`Total Unit Rate of R1`}
          prefix={<RupeesSign />}
          value={calculateTotalUnitRateOfR1(record)} // Assuming unit_rate_of_cement is a property in the record
          style={{ width: "300px", top: "10px" }} // Adjust width as needed
          disabled
        />
      </>
    );
  };

  const calculateTotalUnitRateOfR1 = (record) => {
    const totalUnitRateOfCementR1 =
      parseFloat(calculateTotalUnitRateOfCementR1(record)) || 0;
    const totalUnitRateOfFreightR1 =
      parseFloat(calculateTotalUnitRateOfFreightR1(record)) || 0;

    return (totalUnitRateOfCementR1 + totalUnitRateOfFreightR1).toFixed(0);
  };

  const columns = [
    {
      title: "Sr.",
      dataIndex: "Sr.No",
      width: "30px",
    },
    {
      title: "City",
      dataIndex: "City",
      width: "40px",
    },
    {
      title: "Site",
      dataIndex: "Site Name",
      width: "30px",
      render: (text, record) => {
        if (record["Site Name"] === "Sub Total") {
          return <span className="subtotal">Sub Total</span>;
        } else if (record["Site Name"] === "City Sub Total") {
          return <span className="citytotal">City Total</span>;
        } else {
          return <span>{text}</span>;
        }
      },
    },
    {
      title: "Vendor",
      dataIndex: "Vendor Name",
      width: 120,
    },
    {
      title: "Rank",
      dataIndex: "rank",
      width: 120,
      align: "center",
      render: (text, record) => {
        if (text?.comparison_ranking === "L1") {
          return (
            <>
              <Tooltip
                color={"#094E8F"}
                placement="left"
                title={<span style={{ color: "#fff" }}>Lowest Price</span>}
              >
                <p className="lowestven">{text?.comparison_ranking}</p>
              </Tooltip>
              <p style={{ color: "#094E8F", marginTop: "10px" }}>
                {text?.other_reason_text &&
                  text?.other_reason_text !== "N/A" &&
                  text?.selected_seasons}
              </p>
            </>
          );
        } else if (text?.comparison_ranking === "L2") {
          return (
            <>
              <Tooltip
                color={"#094E8F"}
                placement="left"
                title={
                  <span style={{ color: "#fff" }}>Second Lowest Price</span>
                }
              >
                <p className="secondLowestven">{text?.comparison_ranking}</p>
              </Tooltip>
              <p style={{ color: "#094E8F", marginTop: "10px" }}>
                {text?.selected_seasons}
              </p>
              <p>
                {text?.other_reason_text &&
                  text?.other_reason_text !== "N/A" &&
                  text?.other_reason_text}
              </p>
            </>
          );
        } else if (text?.comparison_ranking === "L3") {
          return (
            <>
              <Tooltip
                color={"#094E8F"}
                placement="left"
                title={
                  <span style={{ color: "#fff" }}>Third Lowest Price</span>
                }
              >
                <p className="thirdLowestven">{text?.comparison_ranking}</p>
              </Tooltip>
              <p style={{ color: "#094E8F", marginTop: "10px" }}>
                {text?.selected_seasons}
              </p>
              <p>{text?.other_reason_text && text?.other_reason_text}</p>
            </>
          );
        } else {
          return (
            <>
              <p>{text?.comparison_ranking}</p>
              <p>{text?.selected_seasons}</p>
              <p>{text?.other_reason_text && text?.other_reason_text}</p>
            </>
          );
        }
      },
    },
    {
      title: "Items",
      dataIndex: "Items",
      width: "80px",
    },
    {
      title: "Diameter",
      dataIndex: "Diameter",
      width: "60px",
      align: "center",
    },
    {
      title: "Qty.",
      dataIndex: "Quantity",
      width: "40px",
      align: "center",
    },
    {
      title: "UoM.",
      dataIndex: "UOM",
      width: "40px",
      align: "center",
      render: (text, record) => {
        if (text === "Cubic Meter") {
          return "Cu. Mtr.";
        } else {
          return text;
        }
      },
    },
    {
      title: "Unit Rate",
      dataIndex: "Unit Rate",
      width: "130px",
      align: "right",
    },
    {
      title: (
        <>
          <span>Total Amount</span>
          <br />
          <span>Without GST</span>
        </>
      ),
      dataIndex: "Total Amount",
      width: "100px",
      align: "right",
      render: (text, record) => {
        if (record["Site Name"] === "Sub Total") {
          return <div className="subtotall">{record["Total Amount"]}</div>;
        } else if (record["Site Name"] === "City Sub Total") {
          return <div className="citytotall">{record["Total Amount"]}</div>;
        } else {
          return <div style={{ marginRight: "10px" }}>{record["Total Amount"]}</div>;
        }
      },
    },
    {
      title: (
        <>
          <span>Total Amount</span>
          <br />
          <span>With GST</span>
        </>
      ),
      dataIndex: "TotalAmountGST",
      width: "100px",
      align: "right",
      render: (text, record) => {
        if (record["Site Name"] === "Sub Total") {
          return <div className="subtotall">{record["TotalAmountGST"]}</div>;
        } else if (record["Site Name"] === "City Sub Total") {
          return <div className="citytotall">{record["TotalAmountGST"]}</div>;
        } else {
          return <div style={{ marginRight: "10px" }}>{record["TotalAmountGST"]}</div>;
        }
      },
    },
  ];

  const handleSubmit = async () => {
    try {
      setBtnLoading(true);

      let response;
      response = await postRequest(
        `po-order/${floatId}/send-purchase-order-for-approval/`
      );

      if (response.data.success) {
        // SuccessNotificationMsg(t("PO Order Sent Successfully"));
        SuccessNotificationMsg(response.data.message);

        navigate("/request-for-quotation/history");
        setBtnLoading(false);
      }
    } catch (error) {
      console.log(error);
      setBtnLoading(false);
    }
  };

  return (
    <>
      <div className="ListingTopBar">
        <div className="pagenamewrap">
          <div className="pagename">
            <h3>Preview and Send for Approval</h3>

            <Breadcrumb className="Breadcrumb-Sec">
              <Breadcrumb.Item>
                <Link to="/request-for-quotation/history">Home</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>Preview and Send for Approval</Breadcrumb.Item>
            </Breadcrumb>
          </div>
          <ButtonField
            className="SaveGradiantBtn"
            type="primary"
            htmlType="PDF"
            label={isDownloading ? "Downloading..." : "Download PDF"}
            onClick={downloadAsPDF}
          />
        </div>
      </div>
<div className="stepscontentwrap">
        <div className="stepsContent">
      <section className="grid-sec mt-5" ref={pdfContainerRef}>
        <div className="PR-body" style={{padding:'0'}}>
          <div className="rgq-num-wrap">
            <h5 className="rfq-number new">
              RFQ Number : <span>{rfqNumber}</span>
              {/* RFQ Number : <span>00501</span>*/}
            </h5>
            <div className="btnwrp2">
              {/* <ButtonField
                className="SaveGradiantBtn"
                type="primary"
                // htmlType="Submit"
                label="Download"

              /> */}

              {/* <ButtonField
                className="SaveGradiantBtn"
                type="primary"
                htmlType="Excel"
                label="Excel"
                // onClick={handleExcelDownload}
                // icon={<img src={ExelDownload} alt="Plus Square" />}
              /> */}
            </div>
          </div>
          <Spin spinning={apiLoading}>
            <Table
              // dataSource={comparativesRFQ}
              dataSource={processedData}
              bordered
              scroll={{
                // x: 1000,
                x: "auto",
              }}
              size="middle"
              pagination={false}
              columns={columns}
              className="comparativecustomtbl"
            />
          </Spin>

          <div className="TotalAMT">
            <label>Total Amount: </label>

            <div
              className="citytotalNum"
              style={{ width: "140px", textAlign: "end", fontWeight: "700" }}
            >
              {poTotalAmount
                ? `\u20B9 ${poTotalAmount.toLocaleString("en-IN", {
                    maximumFractionDigits: 0,
                  })}`
                : 0}
            </div>

            {/* <Input disabled className='InputTotal' value={poTotalAmount ? `\u20B9 ${poTotalAmount.toLocaleString('en-IN', { maximumFractionDigits: 0 })}` : 0}  /> */}
          </div>

        
        </div>
      </section>
      </div>
      <div className="FormFooter bidftr" style={{padding:'16px  ', margin:'0', justifyContent:'space-between', alignItems:'center'}}>
            <div>
              <h5 className="rfq-number new">
                {/* Buyer : <span>{buyer}</span> */}
                Buyer :{" "}
                <span style={{ marginRight: "20px" }}>
                  {buyer ? buyer : "N/A"}
                </span>
                {/* Final Approver :{" "}
                <span style={{ marginRight: "20px" }}>
                  {firstApprover ? firstApprover : "N/A"}
                </span> */}
                {/* Second Approver :{" "}
                <span style={{ marginRight: "20px" }}>
                  {secondApprover ? secondApprover : "N/A"}
                </span> */}
              </h5>
            </div>
            <div className="FormFooter2">
              <ButtonField
                type="primary"
                className="CancelGradiantBtn"
                htmlType="button"
                label={t("Previous")}
                onClick={() => {
                  categoryType
                    ? navigate(
                        `/request-for-quotation/summarypricecomparatives/${id}`
                      )
                    : navigate(
                        `/request-for-quotation/summarypricecomparatives-by-diameter/${id}`
                      );
                }}
              />
              {isCompleted === false && (
                <ButtonField
                  className="SaveGradiantBtn"
                  type="primary"
                  label="Send For Approval"
                  onClick={handleSubmit}
                  loading={btnLoading}
                />
              )}
              {isCompleted === true && (
                <ButtonField
                  className="SaveGradiantBtn"
                  type="primary"
                  label="Back to RFQ History"
                  onClick={() => navigate("/request-for-quotation/history")}
                  loading={btnLoading}
                />
              )}
            </div>
          </div>
      </div>
    </>
  );
};

export default PreviewAndSendApprovalDiameterWise;
